import {
  USER_LOGGED_IN,
  USER_PROFILE_RETURNED,
  USER_LOGGED_OUT
} from "./types";
import api from "../api/Authentication";

/**
 * Returns an action that the specified user has been logged in
 * @param {Object} user
 */
export const userLoggedIn = user => ({
  type: USER_LOGGED_IN,
  user
});

/**
 * Returns an action that includes a requested user profile
 * @param {Object} profile
 */
export const userProfileReturned = profile => ({
  type: USER_PROFILE_RETURNED,
  profile
});

/**
 * Returns an action that the user has been logged out
 */
export const userLoggedOut = () => ({
  type: USER_LOGGED_OUT
});

/**
 * Dispatches a login action via API using the given credentials
 * @param {Object} credentials
 */
export const login = credentials => dispatch =>
  api.User.loginWithCredentials(credentials).then(user =>
    dispatch(userLoggedIn(user))
  );

/**
 * Dispatches a profile request via API using the current user
 */
export const profile = () => dispatch =>
  api.User.currentUser().then(user => dispatch(userProfileReturned(user)));



// WEBPACK FOOTER //
// ./src/actions/auth.js